// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem__NavigationItem__3X5de","active":"NavigationItem__active__SlH7U"};